import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeLoader, openLoader } from '../../redux_toolkit/Loader'
import { updateFavourite } from '../../services/v3/Favourite/FavouriteService'

import {
    closeSoldStyleChangePopup,
    useSoldStyleFav
} from '../../redux_toolkit/Favourite/SoldStyleFavSlice'
import { getUserInfo } from '../../helpers/Util'
import ModalContainer from '../../common/modal/ModalContainer'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'

const SoldStyleChangePopup = () => {
    const soldStyleFavInfo = useSelector(useSoldStyleFav)
    const [description, setDescription] = useState('Show me some options')
    const [showSuccessMessage, setShowSuccessMessage] = useState(false)
    const dispatch = useDispatch()
    const userInfo = getUserInfo()

    const handleSubmit = async () => {
        try {
            dispatch(openLoader())
            const apiParams = `${soldStyleFavInfo?.selectedStyle?.id}?folderId=${soldStyleFavInfo.soldFolderId}&addedToFavouriteById=${userInfo?.id}&remarks=${description}`
            const response = await updateFavourite(apiParams)
            if (response) {
                setShowSuccessMessage(true)
            }
            dispatch(closeLoader())
        } catch (error) {
            dispatch(closeLoader())
        }
    }

    useEffect(() => {
        if (showSuccessMessage) {
            setTimeout(() => {
                dispatch(closeSoldStyleChangePopup())
            }, 5000)
        }
    }, [showSuccessMessage])

    const onCloseModal = () => {
        dispatch(closeSoldStyleChangePopup())
    }

    return (
        <ModalContainer className='sold-style-fav-modal'>
            <div className='common-popup rounded-md'>
                <div className='common-popup-header d-flex justify-content-between'>
                    <div className='popup-tilte'>
                        {!showSuccessMessage && (
                            <h3 className='semibold-16 mb-0'>
                                Do you want any change?
                            </h3>
                        )}
                    </div>

                    <div
                        className='close-btn cursor-pointer'
                        onClick={onCloseModal}
                    >
                        <CloseIcon />
                    </div>
                </div>

                <div className='common-popup-body'>
                    <div className='sold-style-change-popup'>
                        <div className='flex justify-end'></div>
                        {!showSuccessMessage ? (
                            <div>
                                <div className='form-group'>
                                    <textarea
                                        placeholder='Write in details'
                                        className='h-20'
                                        onChange={(e) =>
                                            setDescription(e.target.value)
                                        }
                                        value={description}
                                    ></textarea>
                                </div>
                                <div className='flex justify-end'>
                                    <button
                                        className='button primary'
                                        onClick={handleSubmit}
                                        disabled={description.length === 0}
                                    >
                                        <span>Submit</span>
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className='pb-8'>
                                <p>
                                    Thanks for your interest. Our AM will
                                    contact you soon. You can find this style
                                    saved under{' '}
                                    <span className='weight-600 mr-1'>
                                        My folders → Sold Interest
                                    </span>
                                    items section.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ModalContainer>
    )
}

export default SoldStyleChangePopup
